export enum Keyboard {
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  Space = " ",
  Enter = "Enter",
  Backspace = "Backspace",
}
